import React from 'react';
import css from './ListingPage.module.css';
import { cardRenderSizes, getLabelsFromOptions, isArrayLength } from '../../util/genericHelpers';
import { Icons, ListingCard, PrimaryButton } from '../../components';
import { useConfiguration } from '../../context/configurationContext';
import { FieldConfigKey } from '../../util/enums';

const AuthorListingsSection = props => {
  const { viewport, listings, listing } = props;
  const { publicData = {} } = listing?.attributes || {};
  const { size = [] } = publicData || {};
  const config = useConfiguration();
  const listingFields = config?.listing?.listingFields || [];

  const listingsLength = (isArrayLength(listings) && listings?.length) || 0;
  const sizeLabels = getLabelsFromOptions(FieldConfigKey.SIZE, size, listingFields);

  return (
    <div className={css.moreItemSeller}>
      <h2 className={css.sectionTitle}>
        {listingsLength} Related listings {sizeLabels ? `to ${sizeLabels}` : ``}{' '}
        <Icons name="rightArrow" />
      </h2>
      <div className={css.listings}>
        {listings.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={cardRenderSizes(false)}
          />
        ))}
      </div>
      {/* <div className={css.viewAllListings}>
        <PrimaryButton>
          <Icons name="search" /> 34 more listing
        </PrimaryButton>
      </div> */}
    </div>
  );
};

export default AuthorListingsSection;
